import { Grid } from 'antd';

/**
 * Экран телефона (уже 768 px): таблицы — карточками, окна и панели — на всю ширину (T-176).
 * Планшет в альбомной ориентации и ноутбук — обычная вёрстка.
 */
export function useIsMobile(): boolean {
  const screens = Grid.useBreakpoint();
  // До первого замера useBreakpoint пуст — считаем экран широким, чтобы не мигала вёрстка.
  return screens.md === false;
}

/** Меню — «бургером» уже 992 px: боковая панель отнимает слишком много места. */
export function useIsNarrow(): boolean {
  const screens = Grid.useBreakpoint();
  return screens.lg === false;
}
